<h2 matDialogTitle mat-dialog-draggable-title>
    {{'reflection.title.send_feedback' | translate}}
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</h2>
<mat-divider></mat-divider>

<div matDialogContent class="mt-3">
    <form [formGroup]="formFeedback">
        <!-- reflection type -->
        <div>
            <mat-form-field class="w-100">
                <mat-label>{{'reflection.title.reflectionType' | translate}}</mat-label>
                <mat-select formControlName="itemTypeId" required>
                    <mat-option>
                        <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                            [placeholderLabel]="'search_form.search' | translate"
                            [formControl]="serviceTypesFilterCtrl">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let item of reflectionType" [value]="item.id">
                        {{item.name}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="formFeedback.controls.itemTypeId.hasError('required')">
                    {{'reflection.errors.type_required' | translate}}
                </mat-error>
            </mat-form-field>
        </div>

        <!-- title -->
        <div>
            <mat-form-field class="w-100">
                <mat-label>{{'reflection.title.title' | translate}}</mat-label>
                <input type="text" matInput formControlName="title" required maxlength="200"
                    (focusout)="focusOut('title')">
                <mat-error *ngIf="formFeedback.controls.title.hasError('required')">
                    {{'reflection.errors.title_required' | translate}}
                </mat-error>
            </mat-form-field>
        </div>

        <!-- content -->
        <div>
            <mat-form-field class="w-100">
                <mat-label>{{'reflection.title.content_feedback' | translate}}</mat-label>
                <textarea matInput formControlName="contentFeedback" rows="5" required maxlength="1000"
                    style="resize: none;" (focusout)="focusOut('contentFeedback')"></textarea>
                <mat-error *ngIf="formFeedback.controls.contentFeedback.hasError('required')">
                    {{'reflection.errors.content_required' | translate}}
                </mat-error>
            </mat-form-field>
        </div>

        <!-- File -->
        <div>
            <mat-label>{{'reflection.title.file' | translate}}</mat-label>
            <hr>
            <div *ngFor="let item of fileNames, index as index"
                [matTooltip]="item"
            >
                <div class="d-flex justify-content-between align-items-center mt-2">
                    <div class="d-flex justify-content-between align-items-center mr-5"
                    style="width: 85%;"
                    >
                        <div class="d-flex align-items-center" style="width: 85%; overflow: hidden; text-overflow: ellipsis;">
                            <em class="fa fa-file fa-fw text-primary"></em>
                            <span class="text-elipsis"> {{item}}</span>
                        </div>
                        <div style="white-space: nowrap; width: 10%;">
                            {{filesSize[index] / 1024 / 1024 | number }} MB
                        </div>
                    </div>
                    <button mat-icon-button type="button" (click)="deleteFile(index)">
                        <i class="fa fa-trash" aria-hidden="true"
                            matTooltip="{{'department_manage.buttons.delete' | translate}}"></i>
                    </button>
                </div>
                <mat-divider></mat-divider>
            </div>
        </div>
        <div class="d-flex align-items-center flex-column mt-3 mb-2" style="gap: 5px;">
            <button mat-raised-button color="primary" (click)="inputUpload.click()" type="button" class="mb-1">
                <mat-icon class="mr-1">cloud_upload</mat-icon>
                {{ 'button.choose_file' | translate }}
            </button>
            <input type="file" #inputUpload id="file" accept="application/pdf,.jpg,.png"
                class="form-control-file vt-input-form d-none mat-stroked-button-create-document" name="file"
                (change)="onSelectedUpload($event)" multiple />
            <span style="color: darkgray;">{{ 'reflection.hint.file_accept' | translate}}</span>
            <span style="color: darkgray;">{{ 'reflection.hint.files_pattern' | translate}}</span>
        </div>
    </form>
</div>
<mat-divider></mat-divider>
<div matDialogAction class="d-flex justify-content-center mt-3">
    <button mat-stroked-button color="primary" (click)="close()" type="button" class="mr-3">
        <mat-icon class="mr-0">cancel</mat-icon>
        <span>&nbsp;{{'form.cancel' | translate}}</span>
    </button>

    <button mat-raised-button color="primary" (click)="sendFeedback()" type="button" [disabled]="!formFeedback.dirty">
        <mat-icon class="mr-0">save</mat-icon>
        <span>&nbsp;{{'reflection.title.send' | translate}}</span>
    </button>
</div>